import PropTypes from 'prop-types';
import { useMemo } from 'react';
import DropdownSelectFilter from '../../../../Filters/DropdownSelectFilter';
import { TourDurationOptions, TourDurationType } from '../../../../../constants';
import useTourFilter from '../../../../../hooks/useTourFilter';

const TourDurationFilter = ({ tripId, variant, filterSpacingClass }) => {
  const { searchObj, filters, applyFilter } = useTourFilter(tripId);

  const options = useMemo(() => {
    const shortest = filters?.shortestDurationMinutes;
    const longest = filters?.longestDurationMinutes;
    const offered = TourDurationOptions.filter(
      (option) =>
        (option.maxDurationMinutes === undefined || shortest === null || shortest === undefined
          ? true
          : shortest <= option.maxDurationMinutes) &&
        (option.minDurationMinutes === undefined || longest === null || longest === undefined
          ? true
          : longest >= option.minDurationMinutes),
    );
    return [{ value: TourDurationType.ANY, label: 'Any duration' }, ...offered];
  }, [filters]);

  const selected = useMemo(() => {
    const current = TourDurationOptions.find(
      (option) =>
        option.minDurationMinutes === searchObj.minDurationMinutes &&
        option.maxDurationMinutes === searchObj.maxDurationMinutes,
    );
    return current ? current.value : TourDurationType.ANY;
  }, [searchObj.minDurationMinutes, searchObj.maxDurationMinutes]);

  const handleChange = (value) => {
    const option = TourDurationOptions.find((duration) => duration.value === value);
    applyFilter({
      minDurationMinutes: option ? option.minDurationMinutes : undefined,
      maxDurationMinutes: option ? option.maxDurationMinutes : undefined,
    });
  };

  return (
    <DropdownSelectFilter
      label="Duration"
      options={options}
      defaultOptionValue={TourDurationType.ANY}
      selectedOptionValue={selected}
      onChange={handleChange}
      variant={variant}
      filterSpacingClass={filterSpacingClass}
      menuWidth="w-56"
    />
  );
};

TourDurationFilter.propTypes = {
  tripId: PropTypes.string,
  variant: PropTypes.string,
  filterSpacingClass: PropTypes.string,
};

TourDurationFilter.defaultProps = {
  tripId: undefined,
  variant: 'outline',
  filterSpacingClass: undefined,
};

export default TourDurationFilter;
